module.exports = __webpack_public_path__ + "img/4.7f7947dc.png";